import { Card, CardContent } from '@mui/material';
import './CardPeriod.scss';

const CardPeriod = ({ children }) => (
    <Card className="core--card-period-container">
        <CardContent>
            {children}
        </CardContent>
    </Card>
);

export default CardPeriod;
